import inMemoryJWT from './inMemoryJWT';
import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import { apiBaseUrl } from './config';

const apiUrl = apiBaseUrl;

export default function deviceEventsDataProvider(url) {
    const httpClient = (url) => {
        const options = {
            headers: new Headers({ Accept: 'application/json' }),
        };
        const token = inMemoryJWT.getToken();
        if (token) {
            options.headers.set('x-access-token', token);
        }
        return fetchUtils.fetchJson(url, options);
    };

    return {
        getList: (resource, params) => {
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
                filter: JSON.stringify(params.filter),
            };
            const url = apiUrl + '/' + resource + '?' + stringify(query);
            return httpClient(url).then(function(response) {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject(new Error("HTTP error" + response.status));
                }
                var ret_data = JSON.parse(response.body);
                var records = Array.isArray(ret_data.result) ? ret_data.result : [];
                return {
                    data: records.map(resource => ({ ...resource, id: resource._id })),
                    total: ret_data.count != undefined ? ret_data.count : records.length,
                };
            });
        },

        getOne: (resource, params) => {
            return httpClient(apiUrl + '/' + resource + '/' + params.id).then(function(response) {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject(new Error("HTTP error" + response.status));
                }
                var ret_data = JSON.parse(response.body);
                return {
                    data: { ...ret_data.result, id: ret_data.result._id },
                };
            });
        },

        getMany: (resource, params) => {
            const query = {
                filter: JSON.stringify({ ids: params.ids }),
            };
            const url = apiUrl + '/' + resource + '?' + stringify(query);
            return httpClient(url).then(function(response) {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject(new Error("HTTP error" + response.status));
                }
                var ret_data = JSON.parse(response.body);
                var records = Array.isArray(ret_data.result) ? ret_data.result : [];
                return {
                    data: records.map(resource => ({ ...resource, id: resource._id })),
                };
            });
        },

        getManyReference: (resource, params) => {
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
                filter: JSON.stringify({
                    ...params.filter,
                    [params.target]: params.id,
                }),
            };
            const url = apiUrl + '/' + resource + '?' + stringify(query);
            return httpClient(url).then(function(response) {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject(new Error("HTTP error" + response.status));
                }
                var ret_data = JSON.parse(response.body);
                var records = Array.isArray(ret_data.result) ? ret_data.result : [];
                return {
                    data: records.map(resource => ({ ...resource, id: resource._id })),
                    total: ret_data.count != undefined ? ret_data.count : records.length,
                };
            });
        },

        create: (resource, params) => Promise.reject('create not implemented'),
        update: (resource, params) => Promise.reject('update not implemented'),
        updateMany: (resource, params) => Promise.reject('updateMany not implemented'),
        delete: (resource, params) => Promise.reject('delete not implemented'),
        deleteMany: (resource, params) => Promise.reject('deleteMany not implemented'),
    };
};
